<style scoped>
.this__alert {
  position: absolute;
  color: #ff6666;
  font-size: 18px;
  margin-top: 7px;
  height: unset !important;
  right: -1px;
}
.this__alert:before {
  color: black !important;
}
.this__alert:after {
  opacity: 1 !important;
}
</style>
<template>
  <a-popover :title="false">
    <template slot="content">
      <div class="p-all">
        {{
          !badBrowser
            ? mprDisabled
              ? $t("MPR: only for 2+")
              : $t("MPR")
            : $t("bad browser for mpr")
        }}
      </div>
    </template>

    <span
      class="tool-group-btn without-arrow"
      v-bind:class="{
        'tool-group-btn__active': isMPR,
        'tool-group-btn__disabled': mprDisabled,
      }"
    >
      <span class="tool-group-btn__item tool-group-btn__icon demo__relative">
        <i class="fa-light fa-cube" @click="updateMPR"> </i>
        <i
          v-if="badBrowser"
          class="fa-duotone fa-solid fa-triangle-exclamation this__alert"
        ></i>
      </span>
    </span>
  </a-popover>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MPRTool",
  data() {
    return {
      mprDisabled: false,
      chromeVersion: undefined,
    };
  },
  computed: {
    ...mapGetters(["isMPR", "readyMPR"]),
    badBrowser() {
      return !this.chromeVersion || this.chromeVersion <= 122;
    },
  },
  beforeDestroy() {
    this.$root.$off("newActiveCanvas", this.newActiveCanvas);
  },
  created() {
    this.$accessModule("mpr_tool", this);
    this.getChromeVersion();
    this.$root.$on("newActiveCanvas", this.newActiveCanvas);
  },
  methods: {
    getChromeVersion() {
      const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
      this.chromeVersion = raw ? parseInt(raw[2], 10) : false;
    },
    newActiveCanvas(canvas) {
      this.mprDisabled = this.isMPR
        ? false
        : canvas.loading || canvas.is_preload || canvas.instances.length <= 5;
    },
    updateMPR() {
      if (this.mprDisabled) {
        return;
      }
      if (!this.isMPR === true) {
        const checkErrorsForMPR = this.checkErrorsForMPR();
        if (checkErrorsForMPR) {
          if (checkErrorsForMPR.notify) {
            this.$notify({
              group: "loggedIn",
              type: "error",
              text: checkErrorsForMPR.error,
            });
          }
          this.$debug(
            "MPR чекер: " +
              (checkErrorsForMPR.debug
                ? checkErrorsForMPR.debug
                : checkErrorsForMPR.error),
            "error",
            checkErrorsForMPR
          );
          return;
        } else {
          this.$store.dispatch("updateIsMPR", true);
        }
      } else {
        if (this.isMPR && this.readyMPR) {
          this.$store.dispatch("updateIsMPR", false);
        } else {
          this.$debug("MPR еще не готов нельзя вырубить", "warning");
        }
      }
    },
    checkErrorsForMPR() {
      const activeCanvas = this.$root.$viewerAPI.getCanvas({ active: true });

      if (activeCanvas.loading || activeCanvas.is_preload) {
        return {
          error: this.$t("MPR: viewport loading"),
          notify: false,
        };
      }
      if (activeCanvas.instances.length === 0) {
        return {
          error: this.$t("MPR: viewport is empty"),
          notify: false,
        };
      }
      if (activeCanvas.instances.length <= 5) {
        return {
          error: this.$t("MPR: only for 2+"),
          notify: true,
        };
      }
      const conf = this.$root.$viewerAPI.getGPUConfiguration();
      if (conf.rendering.useCPURendering) {
        return {
          error: this.$t("MPR: hpu tier == 0"),
          notify: true,
          debug: "ГПУ: " + conf.gpuTier.gpu,
        };
      }
      const modality = this.$root.$viewerAPI.getModalityForCanvas(
        activeCanvas.id
      );
      if (
        activeCanvas.type === "STACK" &&
        this.$root.$viewerAPI.possibleModalityForMPR.indexOf(modality) === -1
      ) {
        return {
          error: this.$t("MPR: modality not support").replace(
            "<modality>",
            modality
          ),
          notify: true,
        };
      }
      return false;
    },
  },
};
</script>
